<template>
<div>
    <form class="tags-dialog control-container" v-show="!isComponentModalActive">
        <h3>Link an item</h3>
        <button class="highlight-popup-item" @click="onTagClicked('Question', '-1', $event)"> <v-icon left small color="#F8b632">question_answer</v-icon> Questions</button>
        <b-field label="">
            <b-autocomplete
                v-model="name"
                :open-on-focus=true
                ref="autocomplete"
                :data="filteredDataArray"
                placeholder="Start typing..."
                @select="option => selected = option">
                <template slot="header">
                    <a @click="showAddNewItem">
                        <span> Add new... </span>
                    </a> 
                </template>
                <template slot-scope="props">
                    <div class="media" @click="onTagClicked(props.option.value, props.option.type, $event)">
                        <div :class="getDropdownIconClass(props.option.type)" style="width:10px;height:10px;margin: 4px 10px 4px 0px;">
                        </div>

                        <div class="media-content">
                            {{ props.option.value }}
                        </div>
                    </div>
                </template>
                <template slot="empty">No results for {{name}}</template>
            </b-autocomplete>
        </b-field>

    </form>
    <b-modal class="filter-modal" :active.sync="isComponentModalActive" has-modal-card>
        <NewItemPopup v-show="isComponentModalActive" @update-new-item="onAddNewItem" v-bind:style="{  position:dialogStyle.position, top:dialogStyle.top, bottom: dialogStyle.bottom, left: dialogStyle.left, right: dialogStyle.right}"></NewItemPopup>
    </b-modal>
</div>
</template>

<script>

import NewItemPopup from './NewItemPopup';
    export default {
        components: {
            NewItemPopup
        },
        props: ['selectionText', 'start', 'end', 'dialogStyle'],
        data() {
            return {
                name: '',
                selected: null,
                isComponentModalActive: false
            }
        },
        computed: {
             filteredDataArray() {
                var allItems = this.$store.state.selectableItems.sort(function(a, b){return a.type-b.type});
                return allItems.filter((option) => {
                    return option.value
                        .toString()
                        .toLowerCase()
                        .indexOf(this.name.toLowerCase()) >= 0
                })
            },
            transcriptId(){
                return this.$route.params.transcript.transcriptId;
            },
            patientId(){
                return this.$route.params.transcript.patientId;
            }
        },
        methods: {
            getDropdownIconClass(type) {
                return "media-left highlight-" + type;
            },
            onAddNewItem (item){
                const me = this;
                const id = me.getUniqueID();

                item.id = id;
                me.$emit('addNewItem',item);
                me.$parent.close()
            },
            onTagClicked (value, type, event){
                const me = this;
                const id = me.getUniqueID();

                me.$emit('tagClicked',{transcriptId: me.transcriptId, value:value, selectionText: me.selectionText, type:type, id:id, start: me.start, end:me.end});
                me.$parent.close()
                event.preventDefault()
            },
            showAddNewItem() {
                this.isComponentModalActive = true
            }
        }
    }
</script>

<style>
.tags-dialog{
    width:inherit;
    height:inherit;
    top:inherit;
    bottom:inherit;
    left:inherit;
    right:inherit;
    position: relative;
    font-weight: 200;
    padding:0px;
}

.tags-dialog .modal-card-foot{
    background:transparent;
}
.tags-dialog h3{
    font-size:12px;
    padding-left:6px;
    color:gray;
    font-weight:bold;
    padding: 10px 17px 0px 17px;
}
.tags-dialog .modal-card{
    overflow: visible;
}
button.highlight-popup-item{
    
    width:100%;
    text-align: left;
    padding: 3px 17px;
    
}

button.highlight-popup-item:hover{
    background:#F1F2Fa;
    
}

button.highlight-popup-item .v-icon{
    margin-bottom: 3px;
}


.tags-dialog input{
    -webkit-box-shadow: none!important;
    box-shadow: none;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #dbdbdb;
    margin-bottom:10px;
}

.tags-dialog input:focus{
    border-bottom: 1px solid #F1F2Fa!important;
}

.tags-dialog div.field{
    padding: 3px 10px;
}

.tags-dialog .dropdown-menu{
    padding-top:0px!important;
    margin:0px;
}

</style>